import { useSeller } from "../contexts/SellerContext";
import { getSymbolForCode, DEFAULT_CURRENCY_CODE } from "../utils/currencyMap";

export const useCurrency = () => {
  const ctx = useSeller();
  const code = ctx?.sellerData?.currency_code || DEFAULT_CURRENCY_CODE;
  return {
    code,
    symbol: getSymbolForCode(code),
  };
};
